import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-crop-yield-sidebar',
  templateUrl: './crop-yield-sidebar.component.html',
  styleUrls: ['./crop-yield-sidebar.component.scss']
})
export class CropYieldSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
